import services from 'services/services';
import * as types from '../../types';

// Import helpers
import { checkFetchErrors } from '../../helpers_actions/convert_helpers';

// ******************** FETCH PROMOTION_OUT_PRODUCTS_FORM DATA ********************
export const fetchPromotionOutForm = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PROMOTION_OUT_PRODUCTS_FORM_LOADING,
			payload: true
		});

		const url = `promotions/${id}/algorithm/out`;
		const { data } = await services.get(url);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PROMOTION_OUT_PRODUCTS_FORM_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PROMOTION_OUT_PRODUCTS_FORM_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
